export default __webpack_public_path__ + "static/22_36-69df8a41793f3ce6e32ce6e3cec1d577.png";